module.exports = __webpack_public_path__ + "static/img/service_items_1.e425553.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service_items_1.jpg
// module id = F9+X
// module chunks = 0